import { Box, Checkbox } from "@material-ui/core";
import { FormattedMessage, useIntl } from "react-intl";

interface SendEmailCheckboxProps {
  isChecked: boolean;
  onChange: (value: boolean) => void;
}

function SendEmailCheckbox({ isChecked, onChange }: SendEmailCheckboxProps) {
  const intl = useIntl();

  return (
    <>
      <Box marginTop={"8px"} display={"flex"} alignItems={"start"}>
        <Checkbox
          name="receiveEmail"
          className={"pqrs-checkbox"}
          onChange={(e) => onChange(e.target.checked ?? false)}
          color="default"
          inputProps={{ "aria-label": "primary checkbox" }}
        />
        <label
          className="form-text"
          style={{ marginTop: "10px", marginLeft: "-5px" }}
        >
          <FormattedMessage id="ReceiveViaEmail" />
        </label>
      </Box>
      {!isChecked && (
        <Box paddingLeft={"2rem"} marginTop={"-0.1rem"}>
          <span className="no-check-email">
            {intl.formatMessage({ id: "NoCheckSendEmail" })}
          </span>
        </Box>
      )}
    </>
  );
}

export default SendEmailCheckbox;
